import { motion } from 'framer-motion'
import { stats } from '@/data/mock-data'
import { GlassmorphicCard } from '@/components/ui/glassmorphic-card'

export default function StatsSection() {
    return (
        <section className="py-16">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={stat.id}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <GlassmorphicCard className="p-8 text-center hover:scale-105 transition-transform duration-300 glow-subtle">
                                <motion.p
                                    initial={{ scale: 0 }}
                                    whileInView={{ scale: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.5, delay: index * 0.1 + 0.2, type: 'spring' }}
                                    className="text-4xl md:text-5xl font-bold gradient-text mb-2"
                                >
                                    {stat.value}
                                </motion.p>
                                <p className="text-theme-muted font-medium text-sm">
                                    {stat.label}
                                </p>
                            </GlassmorphicCard>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}
